export var Sounds;
(function (Sounds) {
    Sounds["NEW_MESSAGE"] = "new-message";
    Sounds["REPLY_MESSAGE"] = "reply-message";
})(Sounds || (Sounds = {}));
export default {
    play(sound) {
        try {
            if (sound === Sounds.NEW_MESSAGE) {
                new Audio("/site-widget/assets/sounds/alert.ogg").play().then(() => { });
            }
            else if (sound === Sounds.REPLY_MESSAGE) {
                new Audio("/site-widget/assets/sounds/chat.ogg").play().then(() => { });
            }
        }
        catch (e) {
            console.error(e);
        }
    },
};
